module.exports = __webpack_public_path__ + "static/img/map.25a8977.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/inform/map.png
// module id = xgCU
// module chunks = 1